import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ItemPeopleOffer from './ItemPeopleOffer';

const ItemClose = () => {
  const { offers } = useSelector((state) => state.detail.detail);
  const { offer, personName } = useSelector((state) => state.detail.detail.offerWinner);

  const [selected, setSelected] = useState(false);
  const handleToogle = () => {
    setSelected(!selected);
  };

  const scrollEvent = () => {
    document.addEventListener('scroll', () => {
      const element = document.querySelectorAll('.sticky-resumen-mobile')[0];
      if (element !== undefined) {
        if (window.scrollY <= 110) {
          element.classList.remove('active');
        } else {
          element.classList.add('active');
        }
      }
    });
  };

  useEffect(() => {
    scrollEvent();
  }, []);

  const thousands = (num) => {
    return num.toString().split('').reverse().join('')
      .replace(/(?=\d*\.?)(\d{3})/g, '$1,')
      .split('')
      .reverse()
      .join('')
      .replace(/^[,]/, '');
  };

  return (
    <>
      <div className="bg-alabaster pt-3 p-sm-3 pb-2 d-block d-sm-none sticky-resumen-mobile">
        <div className="wrap">
          <button
            type="button"
            className="bg-alabaster header d-flex justify-content-between btn-link text-left"
            onClick={handleToogle}>
            <div className="title">
              <h3 className="text-tangaroa text-left">Subasta cerrada en:</h3>
              <h3 className="text-tangaroa text-left">
                {`${thousands(offer)} Puntos Aeroméxico Rewards`}
              </h3>
            </div>
            <div className="icon-title font-weight-bold text-horizon">
              {selected ? (<i className="fas fa-minus" />) : (<i className="fas fa-plus" />)}
            </div>
          </button>

          {selected && (
            <div className="content bg-alabaster pb-2">
              <div className="wrap-content">
                <h4 className="mt-30">Ganador</h4>
                <div className="text-dark-blue">
                  <i className="fas fa-user-circle mr-2" />
                  {personName}
                </div>
              </div>
            </div>
          )}

        </div>
      </div>

      <div className="bg-alabaster p-3 pt-5 d-none d-sm-block">
        <h3 className="text-tangaroa text-left">Subasta cerrada en:</h3>
        <h3 className="text-tangaroa text-left">
          {`${offer.toLocaleString()} Puntos Aeroméxico Rewards`}
        </h3>
        <h4 className="mt-30">Ganador</h4>
        <div className="text-dark-blue">
          <i className="fas fa-user-circle mr-2" />
          {personName}
        </div>

        <div className="d-none d-sm-block">
          <hr />
          <div className={offers.length > 8 ? 'max-offer' : ''}>
            <h3 className="text-left mt-30">Ofertas realizadas</h3>
            {offers.map((o) => (
              <div key={o.offer}>
                <ItemPeopleOffer
                  offer={o.offer}
                  person={o.personName}
                  type="Closed" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemClose;
